import React from'react';import PropTypes from'prop-types';import ToastContext from"../../providers/toast/context";/**
 * The Toaster component.
 * @returns {JSX}
 */var Toaster=function Toaster(_ref){var render=_ref.render;return React.createElement(ToastContext.Consumer,null,function(context){return render(context);});};export default Toaster;